import { render, staticRenderFns } from "./AuthorCardProfile.vue?vue&type=template&id=67f929c8&scoped=true&"
import script from "./AuthorCardProfile.vue?vue&type=script&lang=ts&"
export * from "./AuthorCardProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorCardProfile.vue?vue&type=style&index=0&id=67f929c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f929c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f929c8')) {
      api.createRecord('67f929c8', component.options)
    } else {
      api.reload('67f929c8', component.options)
    }
    module.hot.accept("./AuthorCardProfile.vue?vue&type=template&id=67f929c8&scoped=true&", function () {
      api.rerender('67f929c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/AuthorCardProfile.vue"
export default component.exports